<script>
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';

export default {
  mixins: [MixedGridFiltersItemList],

  emits: ['onItemSelected'],

  methods: {
    getInputId(item) {
      return `filtersub-desktop-${this.filter.id}-${item.value}`;
    },
  },
};
</script>

<template>
  <div
    class="color-grid flex-grid flex-grid--x--base flex-grid--y--base"
    data-cy="mixed-grid-filter-list"
    :data-cy-filter-id="filter.id"
  >
    <div v-for="item in filter.items" :key="item.value" class="color-grid__item">
      <div v-if="item.valueName" class="checkbox checkbox--circle">
        <input
          :id="getInputId(item)"
          :data-cy="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          :disabled="itemIsDisabled(item)"
          :checked="itemIsActive(item)"
          type="checkbox"
          :name="getInputId(item)"
          :value="item.value"
          class="checkbox__input"
          @change="$emit('onItemSelected', filter.id, item.value)"
        />
        <label
          :for="getInputId(item)"
          :data-cy-filter-value="item.label"
          class="checkbox__label"
          :style="`--checkbox-bg: ${item.valueName}`"
        >
          {{ item.label }}
        </label>
      </div>
    </div>
  </div>
</template>
